import axios from 'axios';

export const apiClient = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const auth = window.Alpine?.store('auth');
  if (auth?.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`;
  }
  if (auth?.currentWorkspaceId) {
    config.headers['X-Workspace-Id'] = auth.currentWorkspaceId;
  }
  const i18n = window.Alpine?.store('i18n');
  if (i18n?.locale) {
    config.headers['Accept-Language'] = i18n.locale;
  }
  return config;
});

let refreshing = false;
let queue = [];

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status !== 401 || original._retry) {
      return Promise.reject(error);
    }

    if (refreshing) {
      return new Promise((resolve, reject) => {
        queue.push({ resolve, reject });
      }).then(() => apiClient(original));
    }

    original._retry = true;
    refreshing = true;

    try {
      const auth = window.Alpine?.store('auth');
      const { data } = await axios.post('/api/v1/auth/refresh', {
        refresh_token: auth?.refreshToken,
      });
      auth?.setTokens(data.data.access_token, data.data.refresh_token);
      queue.forEach(({ resolve }) => resolve());
      queue = [];
      return apiClient(original);
    } catch (refreshError) {
      queue.forEach(({ reject }) => reject());
      queue = [];
      // Logout on any HTTP error from refresh (4xx/5xx = invalid/expired token)
      // Only spare pure network errors (no response) to avoid logout on flaky connections
      if (refreshError?.response) {
        window.Alpine?.store('auth')?.logout();
      }
      return Promise.reject(error);
    } finally {
      refreshing = false;
    }
  },
);
